import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as S from './styled';
const BaseCardMetaDataWrapper = styled.div`
  ${S.StyledBaseCardMetaData}
  ${props => S[props.hasBodyBackground]};
`;

const BaseCardMetaData = ({
  children,
  hasBodyBackground
}) => /*#__PURE__*/React.createElement(BaseCardMetaDataWrapper, {
  hasBodyBackground: hasBodyBackground
}, children);

BaseCardMetaData.propTypes = {
  hasBodyBackground: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};
export default BaseCardMetaData;